import { AxiosResponse, AxiosInstance, AxiosRequestConfig } from "axios"

import { ResponseData } from "commonModule/services/common"

interface SetUpAccountPasswordRequestData {
  password: string
}

export interface SetUpAccountPasswordRequest
  extends Partial<AxiosRequestConfig> {
  data: SetUpAccountPasswordRequestData
}

export interface SetUpAccountPasswordResponseData extends ResponseData {
  message: string
  isFirstLogin: boolean
  updateEmail: boolean
  updateMobile: boolean
}

export interface SetUpAccountPasswordResponse extends AxiosResponse {
  data: SetUpAccountPasswordResponseData
}

export function setUpAccountPasswordAPI(
  { data }: SetUpAccountPasswordRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    data,
    method: "put",
    url: "/auth/password/update",
  }) as Promise<SetUpAccountPasswordResponse>
}
